import PropTypes from 'prop-types';
import {sizes} from './types';

export const sizePropType = PropTypes.oneOf(sizes);
